<template>
  <section class="home-showcase">
    <header>
      <h2>{{ $t('home.showcaseTitle') }}</h2>
      <p class="subtitle">{{ $t('home.showcaseSubtitle') }}</p>
    </header>
    <div class="showcase-track-wrapper">
      <div class="showcase-track">
        <div class="showcase-card" v-for="(item, i) in allCards" :key="i"
             :class="'showcase-card--' + ((i % 8) + 1)">
          <div class="showcase-card__badge" :class="'badge--' + item.platform">
            <i v-if="item.icon" :class="item.icon"></i>
            <svg v-else viewBox="0 0 24 24" class="x-logo" aria-label="X">
              <path fill="currentColor" d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </div>
          <img v-lazy="item.src" alt="" draggable="false">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeShowcase',
  computed: {
    cards () {
      return [
        { src: require('../../../static/images/home/case1.jpg'), platform: 'fb', icon: 'fa fa-facebook' },
        { src: require('../../../static/images/home/case2.jpg'), platform: 'ins', icon: 'fa fa-instagram' },
        { src: require('../../../static/images/home/case3.png'), platform: 'fb', icon: 'fa fa-facebook' },
        { src: require('../../../static/images/home/case4.png'), platform: 'fb', icon: 'fa fa-facebook' },
        { src: require('../../../static/images/home/case5.png'), platform: 'x', icon: '' },
        { src: require('../../../static/images/home/case6.jpg'), platform: 'fb', icon: 'fa fa-facebook' },
        { src: require('../../../static/images/home/case7.jpg'), platform: 'ins', icon: 'fa fa-instagram' },
        { src: require('../../../static/images/home/case8.jpg'), platform: 'fb', icon: 'fa fa-facebook' }
      ]
    },
    allCards () {
      return [...this.cards, ...this.cards]
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/variables';

.home-showcase {
  padding: 5rem 0;
  background: #fff;
  overflow: hidden;

  header {
    text-align: center;
    margin-bottom: 3rem;
    padding: 0 1.5rem;
  }

  .showcase-track-wrapper {
    position: relative;
    width: 100%;
    overflow: hidden;
    padding: 2rem 0;

    // Fade edges
    &::before, &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 120px;
      z-index: 2;
      pointer-events: none;
    }
    &::before {
      left: 0;
      background: linear-gradient(to right, #fff, transparent);
    }
    &::after {
      right: 0;
      background: linear-gradient(to left, #fff, transparent);
    }
  }

  .showcase-track {
    display: flex;
    gap: 1.5rem;
    animation: showcase-scroll 40s linear infinite;
    width: max-content;
  }

  .showcase-card {
    flex-shrink: 0;
    width: 220px;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s;
    background: #f8f9fc;
    position: relative;

    // Stagger heights
    &--1, &--5 { margin-top: 0; }
    &--2, &--6 { margin-top: 2.5rem; }
    &--3, &--7 { margin-top: 0.5rem; }
    &--4, &--8 { margin-top: 3rem; }

    &:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    }

    &__badge {
      position: absolute;
      bottom: 12px;
      right: 12px;
      width: 32px;
      height: 32px;
      border: 3px solid rgba(255, 255, 255, 0.8);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 3;
      font-size: 15px;
      color: #fff;

      &.badge--fb {
        background: rgba(24, 119, 242, 0.85);
      }
      &.badge--ins {
        background: linear-gradient(135deg, rgba(240, 148, 51, 0.85), rgba(220, 39, 67, 0.85), rgba(188, 24, 136, 0.85));
      }
      &.badge--x {
        background: rgba(0, 0, 0, 0.85);
        color: #fff;
        .x-logo {
          width: 16px;
          height: 16px;
        }
      }
    }

    img {
      width: 100%;
      height: 300px;
      object-fit: cover;
      display: block;
    }
  }

  .showcase-cta {
    text-align: center;
    margin-top: 3rem;
  }
}

@keyframes showcase-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

@media (max-width: 768px) {
  .home-showcase {
    padding: 3.5rem 0;

    .showcase-card {
      width: 160px;

      img {
        height: 220px;
      }

      &--2, &--6 { margin-top: 1.5rem; }
      &--4, &--8 { margin-top: 2rem; }
    }

    .showcase-track {
      gap: 1rem;
    }
  }
}
</style>
